<ng-container
    *ngrxLet="{
        areLabelsVisible: areLabelsVisible$,
        selectedCheckin: selectedCheckin$,
        shouldShowSimplifiedLabel: shouldShowSimplifiedLabels$,
        isSelectionEnabled: isSelectionEnabled$,
        checkinAreaEntities: checkinAreaEntities$
    } as vm"
>
    <dtm-map-html-cesium-component *ngFor="let checkin of vm.checkinAreaEntities" [coordinates]="checkin.centerPosition">
        <ng-container *ngIf="(vm.areLabelsVisible || vm.shouldShowSimplifiedLabel) && checkin.data as checkinData">
            <div
                class="segment-pin simple"
                [class.selectable]="vm.isSelectionEnabled"
                *ngIf="!vm.areLabelsVisible && vm.shouldShowSimplifiedLabel && checkin.id !== vm.selectedCheckin?.id"
                (click)="checkinSelect.emit(checkinData.id)"
                [ngClass]="checkinData | invoke : getCheckinClass : vm.selectedCheckin"
            >
                <dtm-ui-icon name="map-pin"></dtm-ui-icon>
            </div>
            <div *ngIf="vm.areLabelsVisible || checkin.id === vm.selectedCheckin?.id">
                <svg width="100" height="100" viewBox="-50 -50 100 100" class="line-connector">
                    <line [attr.x1]="0" [attr.y1]="0" [attr.x2]="0" [attr.y2]="-50" />
                    <circle r="4" cx="0" cy="0" />
                </svg>
                <div
                    class="segment-pin"
                    [class.selectable]="vm.isSelectionEnabled"
                    [ngClass]="checkinData | invoke : getCheckinClass : vm.selectedCheckin"
                    (click)="toggleCheckingSelection(checkinData)"
                >
                    <div class="header">
                        <dtm-ui-icon name="map-pin"></dtm-ui-icon>
                        {{ "dtmMapCesium.checkinAreaLayer.checkinLabel" | transloco }}
                    </div>
                    <div class="header sub">
                        {{
                            "dtmMapCesium.checkinAreaLayer.heightAglLabel"
                                | transloco : { height: checkinData.heightAgl | localizeNumber : { maximumFractionDigits: 0 } }
                        }}
                        <p>
                            {{
                                "dtmMapCesium.checkinAreaLayer.heightAmslLabel"
                                    | transloco : { height: checkinData.amslCeil | localizeNumber : { maximumFractionDigits: 0 } }
                            }}
                        </p>
                    </div>
                    <div class="content">
                        <div class="indicator"></div>
                        {{ checkinData.flightStartAt | localizeDate : { timeStyle: "short" } }}
                        -
                        {{ checkinData.flightFinishAt | localizeDate : { timeStyle: "short" } }}
                    </div>
                </div>
            </div>
        </ng-container>
    </dtm-map-html-cesium-component>
</ng-container>
